import style from "../css/CompanyPolicies.module.scss";
import refundAndCancellationPolicy from "../../assets/images/ghsi-cancellation-and-refund-policy.jpg";

const CompanyPolicies = () => {
  return (
    <>
      <div className={style.mainContainer}>
        <h1 className="title">Company Policies</h1>

        <img src={refundAndCancellationPolicy} />
      </div>
    </>
  );
};

export default CompanyPolicies;
